export function isSuccessStatusCode(statusCode: number) {
  return statusCode >= 200 && statusCode < 300;
}
